import { Button } from "./Button";

interface PaginationProps {
  page: number;
  perPage: number;
  total: number;
  onPageChange: (page: number) => void;
  onPerPageChange?: (perPage: number) => void;
  perPageOptions?: readonly number[];
}

/** Erişilebilir sayfalama kontrolü. */
export function Pagination({
  page,
  perPage,
  total,
  onPageChange,
  onPerPageChange,
  perPageOptions = [10, 25, 50, 100],
}: PaginationProps) {
  const pageCount = Math.max(1, Math.ceil(total / perPage));
  const firstItem = total === 0 ? 0 : (page - 1) * perPage + 1;
  const lastItem = Math.min(total, page * perPage);

  return (
    <div className="border-border flex flex-wrap items-center justify-between gap-3 border-t px-3 py-3">
      <p className="text-muted-foreground text-xs">
        {total === 0 ? "Kayıt yok" : `${firstItem}–${lastItem} / ${total} kayıt`}
      </p>
      <div className="flex items-center gap-3">
        {onPerPageChange ? (
          <label className="text-muted-foreground flex items-center gap-2 text-xs">
            Sayfa başına
            <select
              aria-label="Sayfa başına kayıt sayısı"
              value={perPage}
              onChange={(event) => onPerPageChange(Number(event.target.value))}
              className="border-border bg-background text-foreground h-8 rounded-md border px-2 text-xs"
            >
              {perPageOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </label>
        ) : null}
        <div className="flex items-center gap-1">
          <Button
            variant="outline"
            size="sm"
            disabled={page <= 1}
            onClick={() => onPageChange(page - 1)}
            aria-label="Önceki sayfa"
          >
            ‹ Önceki
          </Button>
          <span className="text-muted-foreground px-2 text-xs" aria-live="polite">
            {page} / {pageCount}
          </span>
          <Button
            variant="outline"
            size="sm"
            disabled={page >= pageCount}
            onClick={() => onPageChange(page + 1)}
            aria-label="Sonraki sayfa"
          >
            Sonraki ›
          </Button>
        </div>
      </div>
    </div>
  );
}